<template>
	<div id="top">
		<Header>
		</Header>
		<div class="container">
			<div class="centerblock">
				<div v-show="doneStatus">
					<div class="reception">
						<div class="reception_block">
							<a href="#" @click.prevent="doReception" :disabled="!isUseableRunst"><img src="@/assets/images/parts/qrBtn.png" /></a>
						</div>
						<div class="username">
							<HeaderCaption>ユーザー名</HeaderCaption>
							<div class="containerblock">{{userName}}</div>
						</div>
						<div class="status">
							<div class="monthlystatus">
								<HeaderCaption>月額会員</HeaderCaption>
								<div v-if="openRunst" class="containerblock">
									<dl v-if="monthlyStatus.status">
										<dt>{{textMonthlyKindName}}</dt>
										<dd>{{textMonthlyLimit}}まで有効</dd>
									</dl>
									<div v-else class="notmonthly">
										月額会員ではありません。
									</div>
									<div class="btn-monthly-block">
										<button class="btn btn-primary btn-monthly" @click.prevent="buySubsc">月額会員確認・購入<SvgCaretRightFill></SvgCaretRightFill></button>
									</div>
									<div v-if="monthlyStatus.start" class="monthlystatus">
										<p>{{textMonthlyStart}}より{{textMonthlyKindName}}として利用可能となります。</p>
									</div>
								</div>
								<div v-else>
									<p class="notopen">11月21日よりお申込み受付開始します</p>
								</div>
							</div>
							<div class="ticketstatus">
								<HeaderCaption>ビジターチケット利用</HeaderCaption>
								<div v-if="openRunst" class="containerblock">
									<div v-if="ticketStatus.status">
										<dl>
											<dt>利用可能回数</dt>
											<dd>{{ticketStatus.count}}回</dd>
										</dl>
									</div>
									<div v-else class="notticket">
										利用可能なビジターチケットはありません。
									</div>
									<div class="btn-ticket-block">
										<button class="btn btn-primary btn-ticket" @click.prevent="buyTicket">ビジターチケット確認・購入<SvgCaretRightFill></SvgCaretRightFill></button>
									</div>
								</div>
								<div v-else>
									<p class="notopen">11月21日よりお申込み受付開始します</p>
								</div>
							</div>
						</div>
					</div>


					<div class="history">
						<HeaderCaption>その他施設予約</HeaderCaption>
						<div class="containerblock">
							<div class="history_loading" v-if="isRunningReservation">
								<LoadingMark>
								</LoadingMark>
							</div>
							<div v-if="!isRunningReservation" class="history_list">
								<table v-if="existReservation" class="history_table">
									<tbody>
										<tr v-for="info, index in listReservations" :key="index" @click.prevent="clickReservation(info)">
											<td>{{reservationDate(info)}}</td>
											<td>{{reservationTime(info)}}</td>
											<td>{{reservationContent(info)}}</td>
										</tr>
									</tbody>
								</table>
								<div v-else class="notrslog">
									予約状況はありません。
								</div>
							</div>
							<div class="btn-reservation-block">
								<a href="https://connect.universal-field.com/reservecategory.html" class="btn btn-reservation" @click.prevent="clickConnect">施設予約<img src="@/assets/images/parts/72.png"></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Reception v-if="flagReception"
			@close-reception="flagReception = false"
		></Reception>
	</div>
</template>

<script>
	import Header from '@/components/Header';
	import {ymdToText} from '@/lib/formatter';
	import Reception from '@/components/Reception';
	import LoadingMark from '@/components/LoadingMark';
	import HeaderCaption from '@/components/common/HeaderCaption';
	import {dateToVal} from '@/lib/formatter';
	
	// SVG
	import SvgCaretRightFill from '@/components/svg/caret-right-fill';
	
	// ランステ受付開始日時
	const OPEN_RUNST_DATEVAL = 202211210900;

	import apiconfig from '../api-config';
	const reservation_url = location.href.indexOf('https://entry.universal-field.com/rsapp/') == 0 ? apiconfig.reservation_url : apiconfig.stgreservation_url;
	const connect_url = location.href.indexOf('https://entry.universal-field.com/rsapp/') == 0 ? apiconfig.connect_url : apiconfig.stgconnect_url;


	export default {
		mixins: [],
		components: {
			Header,
			Reception,
			LoadingMark,
			SvgCaretRightFill,
			HeaderCaption
		},
		props: {
		},
		data () {
			return {
				flagReception: false,
				doneStatus: false,
				openRunst: false,
				tidOpenRunst: null
			};
		},
		computed: {
			isLogin() {
				return this.$store.getters['commonStore/isLogin'];
			},
			userName() {
				return this.$store.getters['commonStore/getUserName'];
			},
			monthlyStatus() {
				return this.$store.getters['commonStore/getMonthlyStatus'];
			},
			textMonthlyKindName() {
				const monthly = this.monthlyStatus;
				if(monthly.kind_info && monthly.kind_info.name) return monthly.kind_info.name;
				return '';
			},
			// 月額有効期限を文字列で取得する
			textMonthlyLimit() {
				const monthly = this.monthlyStatus;
				if(monthly.limit) return ymdToText(monthly.limit);
				return '';
			},
			// 月額開始日を文字列で取得する
			textMonthlyStart() {
				const monthly = this.monthlyStatus;
				if(monthly.start) return ymdToText(monthly.start);
				return '';
			},
			ticketStatus() {
				return this.$store.getters['commonStore/getTicketStatus'];
			},
			// ランステを利用可能か
			isUseableRunst() {
				return this.$store.getters['commonStore/isUseableRunst'];
			},
			// ランステ利用状況取得中
			isRunningRunstLog() {
				return this.$store.getters['commonStore/getRunningRunstLog'];
			},
			// ランステ利用状況リスト
			listRunningRunstLog() {
				const runst_list = this.$store.getters['commonStore/getListRunstLog'];
				return runst_list;
			},
			// ランステ利用状況が存在するか
			existRunstLog() {
				const runst_list = this.$store.getters['commonStore/getListRunstLog'];
				return runst_list && Array.isArray(runst_list) && runst_list.length;
			},
			// 予約状況取得中
			isRunningReservation() {
				return this.$store.getters['commonStore/getRunningReservation'];
			},
			// 予約状況リスト
			listReservations() {
				const runst_list = this.$store.getters['commonStore/getListReservation'];
				return runst_list;
			},
			// 予約状況が存在するか
			existReservation() {
				const runst_list = this.listReservations;
				return runst_list && Array.isArray(runst_list) && runst_list.length;
			},
		},
		methods: {
			doReception() {
				this.flagReception = true;
			},
			buyTicket() {
				this.$router.push('/ticket');
			},
			buySubsc() {
				this.$router.push('/subscription');
			},
			historyDate(history) {
				return ymdToText(history.ymd);
			},
			historyContent(history) {
				return history.desc;
			},
			reservationDate(info) {
				return info.open_date;
			},
			reservationTime(info) {
				return info.start_time.substr(0,5)+'～'+info.end_time.substr(0,5);
			},
			reservationContent(info) {
				return info.category_name;
			},
			clearOpenRunstInterval() {
				if(this.tidOpenRunst) {
					clearInterval(this.tidOpenRunst);
					this.tidOpenRunst = null;
				}
			},
			clickReservation(info) {
				this.$store.dispatch('commonStore/getServiceToken').then((rslt) => {
					if(rslt.payload && rslt.payload.token) {
						const url = reservation_url+'/reserve-change/'+info.reservation_id+'?token='+rslt.payload.token;
						location.href = url;
					}
				});
			},
			clickConnect() {
				this.$store.dispatch('commonStore/getServiceToken').then((rslt) => {
					if(rslt.payload && rslt.payload.token) {
						const url = connect_url+'?token='+rslt.payload.token;
						location.href = url;
					}
				});
			},
		},
		mounted() {
			this.openRunst = dateToVal(new Date()) >= OPEN_RUNST_DATEVAL;
			if(!this.openRunst) {
				this.tidOpenRunst = setInterval(() => {
					console.log(dateToVal(new Date()), OPEN_RUNST_DATEVAL);
					if(dateToVal(new Date()) >= OPEN_RUNST_DATEVAL) {
						this.openRunst = true;
						this.clearOpenRunstInterval();
					}
					
				}, 10*1000);
			}

			
			if(!this.isLogin) {
				this.$router.push('/login');
				return;
			}
			this.$store.dispatch('commonStore/runstStatus').then(() => {
				this.doneStatus = true;
				this.$store.commit('commonStore/setLoading', false);

				this.$store.dispatch('commonStore/apiRunstLog');

				this.$store.commit('commonStore/setLoading', false);

				const dt = new Date();
				const param = {
					symd: dt.getFullYear()*10000+(dt.getMonth()+1)*100+dt.getDate()*1
				};
				this.$store.commit('commonStore/setRunningReservation', true);
				this.$store.dispatch('commonStore/listupReservations', param).then(() => {
					this.$store.commit('commonStore/setRunningReservation', false);
				});

			});
		},
		destroyed() {
			this.clearOpenRunstInterval();
		}
	};
</script>

<style lang="scss" scoped>
	#top {
		margin: 0 auto;
		padding: 0 8px 0;
		height: 100vh;
		
		.container {
			width: 100%;
			.centerblock {
				.reception {
					.reception_block {
						width: 100%;
						text-align: center;
						padding-top: 32px;
						margin-bottom: 32px;
						img {
							max-width: 33%;
						}
					}
					.btn-monthly-block,
					.btn-ticket-block {
						width: 100%;
						text-align: center;
						padding-bottom: 32px;
						.btn-monthly,
						.btn-ticket {
							position: relative;
							padding-left: 32px;
							padding-right: 32px;
							svg {
								position: absolute;
								right: 4px;
								width: 20px;
								height: 20px;
								top: 50%;
								margin-top: -10px;
								path {
									fill: #fff;
								}
							}
						}
					}
				}
				
				.containerblock {
					padding: 8px;
				}
				.notopen {
					font-size: 14px;
					line-height: 3;
					text-align: center;
				}

		
				.notmonthly {
					font-size: 14px;
					line-height: 1.7;
					padding-bottom: 16px;
				}
				.notticket {
					font-size: 14px;
					line-height: 1.7;
					padding-bottom: 16px;
				}
				.notrslog {
					font-size: 14px;
					line-height: 1.7;
					padding-bottom: 16px;
				}

				
			}
		}
		.history {
			.history_loading {
				width: 32px;
				height: 32px;
				margin: 0 auto;
			}
			table {
				font-size: 12px;
				width: auto;
				&.history_table {
					td {
						cursor: pointer;
						border-bottom: dotted 1px #ccc;
					}
					td:nth-child(1) {
						text-align: center;
					}
					td:nth-child(2) {
						padding-left: 4px;
						padding-right: 4px;
					}
				}
			}
			.btn-reservation-block {
				display: flex;
				justify-content: center;
				a {
					display: flex;
					width: auto;
					align-items: center;
					img {
						height: 16px;
						margin-left: 0.5em;
					}
				}
			}
		}
		.cmdbox {
			display: flex;
			padding: 1em;
			button {
				margin: 0 1em;
			}
		}
	}
</style>
